export function facturesReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_FACTURE":            
        case "UPDATE_FACTURE":
            let list = Object.assign({}, state);
            list[payload.facture_id] = payload
            
            return list
        case "GET_FACTURES":
            return payload
        case "DELETE_FACTURE":            
            let list4 = Object.assign({}, state);
    
            delete list4[payload.facture_id]
            return list4
             
        case "UPDATE_FACTURE_REST":            
            let list5 = Object.assign({}, state);
    
            list5[payload.income_facture_id].facture_rest_to_pay -= payload.income_amount
            list5[payload.income_facture_id].facture_total_payed += payload.income_amount
            if (list5[payload.income_facture_id].facture_rest_to_pay <= 0) {
                list5[payload.income_facture_id].facture_fully_paid = true
            } else {
                list5[payload.income_facture_id].facture_fully_paid = false

            }
            return list5
             
        default:
            return state;
    }
    
}